<template>
  <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="基础注册促销" name="first">
      <general :get-status="general_status"></general>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
// import distributor from './distributorIndex'
import general from './yibaoinfo'

export default {
  components: {
    // distributor,
    general
  },
  data () {
    return {
      activeName: 'first',
      general_status: true,
      
    }
  },
  methods: {//充值送钱
    handleClick () {
      if (this.activeName === "first") {
        this.general_status = true
      }
    }
  },
  mounted () {
    if (this.$route.query.name) {
      this.activeName = this.$route.query.name
    }
    if (this.activeName === "first") {
      this.general_status = true
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// yibao.vue?1c556ee3